const arrows = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='672'
		height='1309'
		viewBox='0 0 672 1309'
		fill='none'
		className='arrows'
	>
		<path
			d='M461.705 665.962L252.66 961.626C245.167 972.223 252.746 986.863 265.724 986.863H423.662C428.781 986.863 433.591 984.413 436.602 980.273L665.082 666.064C669.197 660.403 669.157 652.725 664.982 647.108L428.036 328.368C425.033 324.329 420.304 321.938 415.271 321.914L253.782 321.15C240.638 321.088 233.031 336.024 240.81 346.619L461.538 647.256C465.613 652.806 465.68 660.341 461.705 665.962Z'
			fill='url(#paint0_linear_5872_4968)'
			fillOpacity='0.8'
		/>
		<path
			d='M-30.6935 668.581L-464.979 1282.81C-472.472 1293.41 -464.894 1308.05 -451.915 1308.05H-103.988C-98.8686 1308.05 -94.0583 1305.6 -91.0475 1301.46L369.082 668.682C373.198 663.022 373.157 655.343 368.982 649.727L-107.855 8.28645C-110.857 4.24693 -115.586 1.85597 -120.62 1.83217L-476.218 0.150319C-489.362 0.0881514 -496.969 15.0238 -489.19 25.6192L-30.8608 649.875C-26.786 655.425 -26.7187 662.959 -30.6935 668.581Z'
			fill='url(#paint1_linear_5872_4968)'
		/>
		<defs>
			<linearGradient
				id='paint0_linear_5872_4968'
				x1='447'
				y1='321'
				x2='447'
				y2='986.863'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='white' />
				<stop
					offset='0.515595'
					stopColor='#F4F4F4'
				/>
				<stop
					offset='1'
					stopColor='white'
				/>
			</linearGradient>
			<linearGradient
				id='paint1_linear_5872_4968'
				x1='-66'
				y1='0'
				x2='-66'
				y2='1308.05'
				gradientUnits='userSpaceOnUse'
			>
				<stop
					offset='0.2'
					stopColor='white'
				/>
				<stop
					offset='0.5'
					stopColor='#F4F4F4'
				/>
				<stop
					offset='0.8'
					stopColor='white'
				/>
			</linearGradient>
		</defs>
	</svg>
);

export { arrows };
